module.exports = __webpack_public_path__ + "2b1cea5d640d09c30fa23484eeb19627.MP3";